/**
 * Red required-field asterisk. Rendered inline after field labels (always,
 * for required fields) and next to section / J-code row headers (only while
 * that section/row has an invalid required value).
 */
const RequiredAsterisk = () => (
  <span aria-hidden="true" className="text-red-600" data-required-asterisk>
    *
  </span>
);

export default RequiredAsterisk;